import React, { Component } from 'react';
import { BodyClass } from '@plone/volto/helpers';
import { Image } from 'semantic-ui-react';

import headerImg from './images/leathercraft-modelling-jspoons-closeup.webp';

class Header extends Component {
  /**
   * Constructor
   * @method constructor
   * @param {Object} props Component properties
   * @constructs WysiwygEditor
   */
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.state = {
      bodyClass: 'header-home',
      mounted: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    // Only register the BodyClass side effect once we're really mounted on the
    // client (see render), and pick up the current scroll position.
    this.setState({ mounted: true });
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (window.scrollY < 30) {
      this.setState({ bodyClass: 'header-home' });
    } else {
      this.setState({ bodyClass: '' });
    }
  }

  render() {
    // BodyClass (react-side-effect) registers itself in componentWillMount, so
    // an instance whose render gets discarded (Suspense / hydration retries)
    // is never unmounted and keeps contributing its initial 'header-home'
    // class to <body> forever. Render it on the server (for the initial HTML)
    // and on the client only after the component has actually mounted.
    const showBodyClass = typeof window === 'undefined' || this.state.mounted;
    return (
      <>
        {showBodyClass && <BodyClass className={this.state.bodyClass} />}
        <div className="full-width" id="header">
          <div className="intro-wrapper">
            <div className="intro">
              <h1>Handmade Leatherworking Tools</h1>
              <div className="header-line" />
            </div>
            <Image
              className="intro-image"
              src={headerImg}
              fetchpriority="high"
              alt="A detailed macro closeup of four stainless steel modelling spoons arranged neatly against a dark, minimalist background."
            />
            <div className="intro-image-overlay" />
          </div>
        </div>
      </>
    );
  }
}

export default Header;
